<template>
  <div class="done">
    <div class="top">
      <img class="header-background" :src="require('@/assets/sun2.svg')">
      <div class="title-container">
        <div class="title">מעולה,
          שמחים שהצטרפת!</div>
      </div>
    </div>
    <div class="message">
      <div class="text">הנה פרטי המנוי שלך:</div>
      <div class="name">סה"כ לתשלום בחודש</div>
      <div class="value">₪45</div>
      <div class="name">כרטיס אשראי לחיוב</div>
      <div class="value">{{ formattedCC }}</div>
      <div class="name">תאריך ראשון לחיוב</div>
      <div class="value">{{ formattedFirstBillingDate }}<span v-if="eligibleForDiscountBenefit"> (הטבת דיסקונט)</span></div>
      <riseup-button :title="'בחזרה לתזרים שלי'" :action="backToCashflow"/>
    </div>
    <div class="footer">
      <div class="text">המשימה שלנו היא להוביל שינוי בחברה הישראלית יחד עם הלקוחות שלנו,
        ולעזור לכל אחד ואחת לצמוח כלכלית.</div>
      <div class="bold">רוצה לקחת חלק?</div>
      <div>זה קורה <a href="https://bit.ly/30X5Ng4" target="_blank" class="link">בקבוצת הפייסבוק שלנו,</a> מחכים לך!</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../Segment';
import router from '../../../../../router';
import dates from '../../../../../utils/dates';

export default {
  name: 'Done',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  async created() {
    Segment.trackUserGot('SubscriptionDoneEntered');
  },
  computed: {
    ...mapState('subscription', ['eligibleForDiscountBenefit']),
    ...mapGetters('subscription', ['cardLast4Digits', 'finalBillingDate']),
    firstBillingDayInMonth() {
      return moment(this.finalBillingDate).date();
    },
    firstBillingMonth() {
      return dates.getHebrewMonth(this.finalBillingDate);
    },
    formattedFirstBillingDate() {
      return `${this.firstBillingDayInMonth} ל${this.firstBillingMonth}`;
    },
    formattedCC() {
      return `${this.cardLast4Digits} **** **** ****`;
    },
  },
  methods: {
    backToCashflow() {
      Segment.trackUserInteraction('SubscriptionDone_BackToCashflowClicked');
      router.push({ path: '/home', query: { hideCta: true } });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../scss/mixins';

  .done {
    position: relative;
    text-align: right;
    margin-bottom: 30px;

    .top {
      position: relative;
      text-align: center;
      margin-bottom: 30px;

      .header-background {
        width: 100%;
      }

      .title-container {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        align-items: center;
        color: $riseup_white;
        justify-content: center;

        .title {
          display: inline-block;
          @include title;
          line-height: 32px;
          white-space: pre-line;
        }
      }
    }

    .message {
      @include responsive-padding;

      .text {
        font-size: 20px;
        line-height: 1.2;
        margin-bottom: 18px;
      }

      .name {
        padding-top: 14px;
        font-size: 14px;
        line-height: 1;
        margin-bottom: 7px;
      }

      .value {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 22px;
      }

      .riseup-button {
        width: 100%;
        margin-top: 10px;
      }
    }

    .footer {
      margin-top: 50px;
      padding: 0px 40px 30px 40px;
      font-size: 16px;
      line-height: 1.38;

      .link {
        font-size: 16px;
        font-weight: bold;
        text-decoration: underline;
        color: $riseup_light_blue;
      }

      .bold {
        font-weight: bold;
        margin-top: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/subscription/pages/Done.vue